/* ⚠️ GENERATED from app/services/chatThemes.ts by gen-twins.mjs — edit the TypeScript, not this. */
// services/chatThemes.ts — the chat themes: eight, each a wallpaper and the bubble that suits it.
//
// 🟢 ONE LIST FOR BOTH CLIENTS. gen-twins.mjs copies this file to the web client
//    (allo-web/src/services/chatThemes.js), so the app's theme screen and the web's
//    appearance panel offer the same eight themes in the same colours, by
//    construction. Pure data and pure functions — no React, no platform.
//
// 🟢 EVERY THEME HAS A LIGHT AND A DARK FACE. A theme is not one colour that is
//    right in one mode and glaring in the other: the wallpaper, the doodle's ink and
//    the outgoing bubble each have a value per mode, and the chat picks the one for
//    the mode it is in. Every bubble carries white text at 4.5:1 or better in both
//    (serverless check: gtest/wallpaper.test.mjs §1).
//
// What a chat saves (chats/{id}.appearance.{uid}):
//     theme:      '<id>'                      → which theme (the mode-aware source of truth)
//     wallpaper:  'tone:<id>' | 'tone:<id>:doodle'   → kept for older app versions and the list tile
//     bubbleColor:'<light bubble>'            → kept for older app versions
// Older encodings still render: 'pattern:<id>', 'pattern:#hex', '#hex', gradients, photos.

export const CHAT_THEMES = [{
  id: 'allo',
  name: 'Allo',
  light: {
    bg: '#EEF1F5',
    ink: '#5B6B82',
    op: 0.16,
    out: '#0A6CDF'
  },
  dark: {
    bg: '#0B0E13',
    ink: '#FFFFFF',
    op: 0.07,
    out: '#0A5FC4'
  }
}, {
  id: 'ocean',
  name: 'Ocean',
  light: {
    bg: '#E2EDF2',
    ink: '#3F6E82',
    op: 0.17,
    out: '#1A6A89'
  },
  dark: {
    bg: '#0B151A',
    ink: '#FFFFFF',
    op: 0.065,
    out: '#155871'
  }
}, {
  id: 'mint',
  name: 'Mint',
  light: {
    bg: '#E1F0EA',
    ink: '#3E7D6C',
    op: 0.17,
    out: '#11735F'
  },
  dark: {
    bg: '#0C1714',
    ink: '#FFFFFF',
    op: 0.065,
    out: '#0F5E4E'
  }
}, {
  id: 'sage',
  name: 'Sage',
  light: {
    bg: '#E6ECE2',
    ink: '#4F6B55',
    op: 0.17,
    out: '#3A6E52'
  },
  dark: {
    bg: '#101712',
    ink: '#FFFFFF',
    op: 0.065,
    out: '#2E5A42'
  }
}, {
  id: 'sand',
  name: 'Sand',
  light: {
    bg: '#F2EADF',
    ink: '#8A7458',
    op: 0.17,
    out: '#975A30'
  },
  dark: {
    bg: '#17130E',
    ink: '#FFFFFF',
    op: 0.065,
    out: '#764826'
  }
}, {
  id: 'blush',
  name: 'Blush',
  light: {
    bg: '#F6E8EB',
    ink: '#8E5A68',
    op: 0.16,
    out: '#AD4266'
  },
  dark: {
    bg: '#1A1114',
    ink: '#FFFFFF',
    op: 0.065,
    out: '#82354F'
  }
}, {
  id: 'lavender',
  name: 'Lavender',
  light: {
    bg: '#ECE8F5',
    ink: '#6A5F92',
    op: 0.16,
    out: '#5F4EC4'
  },
  dark: {
    bg: '#13111C',
    ink: '#FFFFFF',
    op: 0.07,
    out: '#4A3E9E'
  }
}, {
  id: 'slate',
  name: 'Slate',
  light: {
    bg: '#E8E9EC',
    ink: '#555B66',
    op: 0.16,
    out: '#2F343C'
  },
  dark: {
    bg: '#09090B',
    ink: '#FFFFFF',
    op: 0.07,
    out: '#3A404B'
  }
}];
export const DEFAULT_THEME = 'allo';

/* ids from earlier palettes, so a chat dressed before keeps a close relative */
const ALIASES = {
  sky: 'ocean',
  lagoon: 'mint',
  teal: 'mint',
  emerald: 'sage',
  grape: 'lavender',
  rose: 'blush',
  sunset: 'sand',
  graphite: 'slate',
  midnight: 'slate',
  default: 'allo',
  doodle: 'allo',
  classic: 'allo'
};

/** A theme by id (or an old id); unknown → null. */
export function themeById(id) {
  if (!id) return null;
  const key = ALIASES[id] || id;
  return CHAT_THEMES.find(t => t.id === key) || null;
}

/** The face for this mode. */
export function themeFace(t, isDark) {
  return isDark ? t.dark : t.light;
}

/** The wallpaper string a theme saves: the doodle is on unless switched off. */
export function themeWallpaper(id, doodle) {
  return `tone:${id}${doodle ? ':doodle' : ''}`;
}

/** Read a 'tone:<id>[:doodle]' wallpaper. Nothing saved is the default theme WITH its doodle. */
export function readTone(spec) {
  if (!spec) return {
    theme: themeById(DEFAULT_THEME),
    doodle: true
  };
  if (!String(spec).startsWith('tone:')) return null;
  const [, id = DEFAULT_THEME, extra = ''] = String(spec).split(':');
  return {
    theme: themeById(id) || themeById(DEFAULT_THEME),
    doodle: extra === 'doodle'
  };
}

/** Which theme a saved appearance is wearing — its `theme`, else its tone wallpaper; null if neither. */
export function themeOfAppearance(s) {
  if (!s) return null;
  const byId = themeById(s.theme);
  if (byId) return byId;
  if (typeof s.wallpaper === 'string' && s.wallpaper.startsWith('tone:')) return readTone(s.wallpaper).theme;
  return null;
}
